import { APIMethod, fetchData } from "@client";

export async function createPaymentMethodQuery(paymentMethodId) {
  return await fetchData("/company/payment/add", APIMethod.POST, {
    data: { paymentMethodId },
    mapRequestKeysToSnakeCase: false
  });
}
